import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Flex Direction Icons - Arrow-based visual representations
// =============================================================================

export function FlexRow(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "FlexRow",
    viewBox: "0 0 16 16",
    path: (
      <path
        d="M3 8h10M10 5l3 3-3 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function FlexRowReverse(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "FlexRowReverse",
    viewBox: "0 0 16 16",
    path: (
      <path
        d="M13 8H3M6 5L3 8l3 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function FlexColumn(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "FlexColumn",
    viewBox: "0 0 16 16",
    path: (
      <path
        d="M8 3v10M5 10l3 3 3-3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function FlexColumnReverse(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "FlexColumnReverse",
    viewBox: "0 0 16 16",
    path: (
      <path
        d="M8 13V3M5 6l3-3 3 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
